import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import banner1 from "../../../Assets/propertyPage/banner.png";
import banner2 from "../../../Assets/propertyPage/bannner2.png"; // Add more banners
import banner3 from "../../../Assets/propertyPage/banner3.png";
import img1 from "../../../Assets/propertyPage/range.svg";
import img2 from "../../../Assets/propertyPage/gender.svg";
import { TbCurrentLocation } from "react-icons/tb";
import { FiSearch } from "react-icons/fi";
import AOS from "aos";
import "aos/dist/aos.css";

function Banner() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      offset: 100,
      delay: 200,
    });
    return () => AOS.refresh();
  }, []);

  const banners = [banner1, banner2, banner3];

  return (
    <div className="lg:mt-[107px] md:mt-[73px] mt-[70px]" data-aos="zoom-out">
      <div data-aos="zoom-out" className="sm:px-16 px-6">
        {/* <h1 className="text-md py-3 text-[#263238] font-semibold tracking-wide">
          Yostel/Odisha/Patia Bhubaneswar
        </h1> */}

        {/* Swiper Banner Slider */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          className="rounded-xl shadow-lg"
        >
          {banners.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Banner ${index + 1}`}
                className="w-full h-auto rounded-xl"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Search and Filters */}
      <div className="flex sm:flex-row flex-col sm:gap-0 gap-5 justify-between items-center sm:px-16 p-6">
        {/* <div className="sm:flex hidden items-center border rounded-md shadow-sm px-4 py-2 sm:w-[50%] w-full">
          <input
            type="text"
            placeholder="Find In and Around...."
            className="flex-1 outline-none bg-transparent text-gray-700 placeholder-gray-500"
          />
          <div className="flex gap-3">
            <button className="p-2 bg-[#EDF6FF] text-[#235784] rounded-full">
              <TbCurrentLocation size={18} />
            </button>
            <button className="py-2 px-4 bg-[#235784] text-white rounded-md">
              <h1 className="text-sm">Search</h1>
            </button>
          </div>
        </div> */}
        {/* <div className="flex  items-center gap-5">
          <div className="border px-3 py-2 rounded-full border-[#AFAFAF] flex items-center gap-2">
            <h1 className="text-[#696969]">Range</h1>
            <img src={img1} alt="range" className="h-5 w-5" />
          </div>
          <div className="flex items-center gap-2 border px-3 py-2 rounded-full border-[#AFAFAF]">
            <h1 className="text-[#696969]">Gender</h1>
            <img src={img2} alt="gender" className="h-4 w-4" />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Banner;
